import { User } from "../interface/User"

export type FilterInputOutput = User[] | undefined

export const useFilter = ({ keyword, users, getFilterResults }: { keyword: string, users: FilterInputOutput, getFilterResults: (keyword: string, users: FilterInputOutput) => FilterInputOutput }): (keyword: string, users: FilterInputOutput) => FilterInputOutput => {
    return (keyword, users) => getFilterResults(keyword, users);
}
